import React from 'react';

const DemoAlreadyVerified = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-2xl w-full p-8 bg-white rounded-lg shadow-lg">
        <div className="text-center">
          <div className="text-5xl text-blue-500 mb-4">ℹ️</div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">This Demo Request Has Already Been Verified</h1>
          
          <p className="text-lg text-gray-700 mb-6">
            You’ve already confirmed this request — no need to verify it again.
          </p>
          
          <div className="bg-gray-100 p-6 rounded-lg mb-6">
            <p className="font-semibold text-lg text-gray-800 mb-2">
              If you haven't spoken with our AI agent yet, hold tight!
            </p>
            <p className="text-gray-700">
              We’ll call the number you submitted very soon. Our lifelike agent will ask a few quick questions to understand your needs.
              Your answers help us prepare a personalized demo that fits your business.
            </p>
          </div>

          <p className="text-gray-700 mb-10">
            Missed the call? No worries — we’ll automatically try again or follow up with mail.
          </p>
          
          <div className="border-t border-gray-200 pt-6">
            <p className="text-gray-600">
              Questions or need help? Reach out to <a href="mailto:info@lifelikeagents.com" className="text-blue-600 hover:underline">info@lifelikeagents.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoAlreadyVerified;